
import { Options, Vue } from "vue-class-component";
import PosService from "../../service/PosService.js";
import ProfilerService from "../../service/ProfilerService.js";
import ChartService from "../../service/ChartService.js";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf, helpers } from "@vuelidate/validators";
import Toaster from "../../helpers/Toaster";
import moment from "moment";
import AutoComplete from "primevue/autocomplete";
import SearchFilter from "../../components/SearchFilter.vue";
import PreviewAccountingReceipt from "../../components/PreviewAccountingReceipt.vue";
import { ref, defineComponent, toRefs, reactive } from "vue";
import PaymentScreen from "../../components/PaymentScreen.vue";
import { useStore, ActionTypes } from "../../store";
import ProfilerDialog from "../../components/ProfilerDialog.vue";
import { ItemList,CounterEntry,PaymentListType } from "../pos_purchase_return/IPurchaseReceipt.js";
import router from "../../router";
import { Watch } from 'vue-property-decorator';
import { nextTick } from "vue";
import FileUploader from "../../components/FileUploader.vue";


@Options({
  title: 'Purchase Returns',
  components: {
    AutoComplete,
    SearchFilter,
    PreviewAccountingReceipt,
    PaymentScreen,
    ProfilerDialog,
    FileUploader
  }
  
})
export default class PosPurchaseReturn extends Vue {
  private paymentDialog = false;
  private validationPopup = false;
  private validationPopupMessage = 'Please fill all the required fields to proceed';
  private profileStatus = false;
  private statusType = "New";
  private storeName = "Loading...";
  private receiptDailog = true;
  private submitted = false;
  private currentUserID = 0;
  private itemScanBox = "";
  private dialogTitle = "";
  private profilerService;
  private posService;
  private toast;
  private storeList = [];
  private profilerList = [];
  private itemList = [];
  private productsList = [];
  private store = useStore();
  private invoiceDiscount: string="";
  private cashPaymentOption = true;
  private cardPaymentOption = true;
  private payLaterOption = false;
  private paySupplierCredit = true;
  private uploaderStatus = false;
  private profileTypes = [
    {key:'Supplier'},
    {key:'Salesman'}
  ];
  private errorDialog = false;
  private validationErrors:any[] = [];
  private taxNames = [
    {
      taxName: "",
      show: false,
      optionalReq: "",
      taxValue: 0,
      accountHead: "",
      accountID: 0,
    },
    {
      taxName: "",
      show: false,
      optionalReq: "",
      taxValue: 0,
      accountHead: "",
      accountID: 0,
    },
    {
      taxName: "",
      show: false,
      optionalReq: "",
      taxValue: 0,
      accountHead: "",
      accountID: 0,
    },
  ];

  private excelFileContent = [
    {
      'productName' : '',
			'productId' : '',
			'batchNo' : '',
			'barcode'      : '',
      'unitQty'      : '',
      'freeQty'      : '',
      'supBonus'      : '',
      'unitPurchase'      : '',
      'unitDisc'      : '',
      'mrp'      : '',
      'cusDisc'      : '',
      'expiryDate'      : '',
      
    }
  ];

  private productItem = 
    {
      'productName' : '',
			'productId' : '',
			'batchNo' : '',
			'barcode'      : '',
      'unitQty'      : '',
      'freeQty'      : '',
      'supBonus'      : '',
      'unitPurchase'      : '',
      'unitDisc'      : '',
      'mrp'      : '',
      'cusDisc'      : '',
      'expiryDate'      : '',
      
    };        

  private state = reactive({
    selectedProfile: "",
    selectedProfileType: "",
    savedItemList: [] as ItemList[],
  });

  //private savedItemList: ItemList[] = [];

  private validationRules = {
    selectedProfile: {
      required,
    },
  };

  private counterEntry: CounterEntry [] = [];

  private paymentList: PaymentListType [] = [];

  private item = {
    id: 0,
    receiptID: 0,
    profileID: 0,
    discount: 0,
    totalPaid: 0,
    totalTendered: 0,
    totalChange: 0,
    totalGrossAmt: 0,
    totalBill: 0,
    totalGoodsValue:0,
    totalTax1: 0,
    totalTax2: 0,
    totalTax3: 0,
    totalTax: 0,
    description: "",
    billNo: "",
    paymentMethod: "",
    searchReceiptNo: "",
    status: "Active",
    type: "RPU",
  };  
  private paidAmount = 0;
  private initialTotalAmount = 0;

  private v$ = useVuelidate(this.validationRules, this.state);

  //DEFAULT METHOD OF TYPE SCRIPT
  created() {
    this.profilerService = new ProfilerService();
    this.posService = new PosService();
    this.toast = new Toaster();
  }

  mounted() {
    this.loadList();
         // Add event listener for keypress
         window.addEventListener('keypress', this.handleKeypress);
  }
  
  beforeUnmount() {
  // Remove event listener
  window.removeEventListener('keypress', this.handleKeypress);
  }

  handleKeypress(event) {
      // Check for "Enter" key to detect the end of scanning
      if (event.key === 'Enter') {
        this.fetchReceiptNo();
      } else {
      }
    } 

  openFileUploader()
  {
    ////console.log("open file uploader");
    this.uploaderStatus = true;
  } 

  get progressBar() {
    return this.store.getters.getProgressBar;
  }
  
  searchProfiler(event) {
    setTimeout(() => {
      this.profilerService.searchProfiler(event.query.trim()).then((data) => {
         // Filter records where account_type is "Supplier"
        const suppliers = data.records.filter(record => record.account_type === "Supplier");
        if (suppliers.length > 0) {
          this.profilerList = suppliers;
        } else {
          this.profilerList = [];
        }
      });
    }, 200);
  }

  searchItem(event) {
    ////console.log("searching purchase");
    setTimeout(() => {
      this.posService.searchPurItem(event.query.trim()).then((data) => {
        if(data.records.length == 0){
          this.toast.showInfo('No Item Found');
        } else {
          this.itemList = data.records;
        }
      });
    }, 200);
  }

  

  adjustQty(type, item) {
    var max_qty = (item.stockQty > item.totalPurchacedUnits) ? item.totalPurchacedUnits : item.stockQty;
    
    if (type == "minus" && item.unit > 1) {
      if(item.unit > max_qty){
        item.unit =  max_qty;
      } else {
        item.unit--;
      }
    } else if (type == "add") {
      if (item.unit < max_qty) {
        item.unit++;
      } else {
        this.toast.showError("Can't refund more than the ordered quantity");
      }
    }
  }


  //This part prevent unneccessary characters being entered in the qty input field
  validateUnit(savedItem, event) {
    // Get the input value
    let inputValue = event.target.value;

    // Allow digits and a single decimal point
    let numericValue = inputValue.replace(/[^0-9.]/g, '');

    // Ensure only one decimal point is allowed
    const parts = numericValue.split('.');
    if (parts.length > 2) {
      // If there are more than one ".", join only the first two parts with a single "."
      numericValue = `${parts[0]}.${parts.slice(1).join('')}`;
    }

    // Parse the value and ensure it's a valid number, allowing intermediate "." inputs
    const finalValue = isNaN(Number(numericValue)) ? numericValue : Number(numericValue);

    // Update savedItem.unit with valid value (keeping as numeric when possible)
    savedItem.unit = finalValue;

    // Update the input field value directly, allowing user to see the current input
    event.target.value = numericValue;
  }

  loadList() {
    this.posService.getItems().then((data) => {
      // //taxNames
      this.taxNames = [];

      this.storeList = data.stores;

      this.taxNames.push({
        taxName: data.storeTaxes[0].tax_name_1,
        show: data.storeTaxes[0].show_1 == "true" ? true : false,
        optionalReq: data.storeTaxes[0].required_optional_1,
        taxValue:
          data.storeTaxes[0].show_1 == "true"
            ? Number(data.storeTaxes[0].tax_value_1)
            : 0,
        accountHead: data.storeTaxes[0].tax_name1.chartName,
        accountID: data.storeTaxes[0].link1,
      });

      this.taxNames.push({
        taxName: data.storeTaxes[0].tax_name_2,
        show: data.storeTaxes[0].show_2 == "true" ? true : false,
        optionalReq: data.storeTaxes[0].required_optional_2,
        taxValue:
          data.storeTaxes[0].show_2 == "true"
            ? Number(data.storeTaxes[0].tax_value_2)
            : 0,
        accountHead: data.storeTaxes[0].tax_name2.chartName,
        accountID: data.storeTaxes[0].link2,
      });

      this.taxNames.push({
        taxName: data.storeTaxes[0].tax_name_3,
        show: data.storeTaxes[0].show_3 == "true" ? true : false,
        optionalReq: data.storeTaxes[0].required_optional_3,
        taxValue:
          data.storeTaxes[0].show_3 == "true"
            ? Number(data.storeTaxes[0].tax_value_3)
            : 0,
        accountHead: data.storeTaxes[0].tax_name3.chartName,
        accountID: data.storeTaxes[0].link3,
      });

      this.currentUserID = data.currentUserID;
      this.storeName = data.storeName;
    });
  }

  getTheSubtotal(data) {
    
    const qty = Number(data.unit);
    const price = Number(data.purchasePrice);
    const discount = Number(data.itemDisc);
    const mrp   = Number(data.mrp);

    const tax1 = data.tax1;
    const tax2 = data.tax2;
    const tax3 = data.tax3;
    const totalTax = tax1 + tax2 + tax3;

    const avgTax = 100 + totalTax;
    const tax = (mrp / avgTax) * totalTax;
		const packPrice = mrp - tax;

    const total = qty * price;
    const unitDiscAmount = (price / 100) * discount;
    const disAmount = (total / 100) * discount;

    const afterDis = total - disAmount;
    const afterTax = (afterDis / 100) * (totalTax);

    const netTotal = afterDis + afterTax;

    data.subTotal = Number(this.fixDigits(netTotal));

    //TOTAL UNITS
    data.totalUnit = (data.packSize * data.unit) + data.freeUnit + data.supplierBonus;
    
    //PACK PRICE
    data.sellingPrice = Number(packPrice);

    //AFTER DISCOUNT PURCHASE PRICE
    data.purchaseAfterDisc = Number(this.fixDigits(price-unitDiscAmount));

    return this.fixDigits(netTotal);
  }

  get totalGross() {
    let total = 0;
    this.state.savedItemList.forEach((e) => {
      total = total + e.purchasePrice * e.unit;
    });

    return total;
  }

  get totalItemValue() {
    let total = 0;
    this.state.savedItemList.forEach((e) => {
      total = total + e.sellingPrice * e.unit;
    });

    return total;
  }

  get totalTax1() {
    let total = 0;

    this.state.savedItemList.forEach((e) => {
      const tax = e.tax1;
      const price = e.purchasePrice * e.unit;
      const afterDisc = (price / 100) * e.itemDisc;
      total = total + ((price - afterDisc) / 100) * tax;
    });

    return Number(total.toFixed(2));
  }

  get totalTax2() {
    let total = 0;
    this.state.savedItemList.forEach((e) => {
      const tax = e.tax2;
      const price = e.purchasePrice * e.unit;
      const afterDisc = (price / 100) * e.itemDisc;
      total = total + ((price - afterDisc) / 100) * tax;
    });

    return Number(total.toFixed(2));
  }

  get totalTax3() {
    let total = 0;
    this.state.savedItemList.forEach((e) => {
      const tax = e.tax3;
      const price = e.purchasePrice * e.unit;
      const afterDisc = (price / 100) * e.itemDisc;
      total = total + ((price - afterDisc) / 100) * tax;
    });

    return Number(total.toFixed(2));
  }

  get totalDiscAmount() {
    let total = 0;
    this.state.savedItemList.forEach((e) => {
      const price = e.purchasePrice * e.unit;
      total = total + (price / 100) * e.itemDisc;
    });

    return total;
  }

  get netTotal() {
    return Number(
      (
        this.totalGross -
        this.totalDiscAmount +
        this.totalTax1 +
        this.totalTax2 +
        this.totalTax3
      ).toFixed(2)
    );
  }

  get totalGoodsValue() {
    return Number(
      (
        this.totalItemValue
      ).toFixed(2)
    );
  }

  fixDigits(amt) {
    let total = 0;

    if (amt != null) {
      total = amt.toFixed(2);
    }
    return total;
  }

  clearAll() {
    
    this.state.savedItemList = [];
    this.paymentList = [];

    this.item = {
      id: 0,
      receiptID: 0,
      profileID: 0,
      discount: 0,
      totalGrossAmt: 0,
      totalBill: 0,
      totalGoodsValue:0,
      totalPaid: 0,
      totalTendered: 0,
      totalChange: 0,
      totalTax1: 0,
      totalTax2: 0,
      totalTax3: 0,
      totalTax: 0,
      description: "",
      billNo: "",
      searchReceiptNo: this.item.searchReceiptNo,
      paymentMethod: "",
      status: "Active",
      type: "RPU",
    };

    this.itemScanBox = "";
    this.state.selectedProfile = "";
    this.state.selectedProfileType = "";
    this.invoiceDiscount = "";
  }

  clearListItem(item) {
    this.state.savedItemList.splice(this.state.savedItemList.indexOf(item), 1);
    this.toast.showSuccess("Item Deleted Successfully");
  }

  limitString(str) {
    // if (str.length > 40) str = str.substring(0, 40) + "...";
    return str;
  }

  closeValidationPopup(){
    this.validationPopup = false;
  }

  closePaymentScreen() {
    this.paymentDialog = false;
  }

  getProceededPayments(paymentList) {
    this.paymentList = paymentList;
    const tenderedList = this.getTotalPaid(paymentList);
    this.item.totalPaid = Number(tenderedList[0]);
    this.item.totalTendered = Number(tenderedList[1]);
    this.item.totalChange = Number(tenderedList[2]);

    const payedMethod = this.getPaymentMethod(paymentList);
    this.item.paymentMethod = payedMethod.payMethod;

    this.item.discount = this.totalDiscAmount;
    this.item.totalGrossAmt = this.totalGross;
    this.item.totalBill = this.netTotal;
    this.item.totalGoodsValue = this.totalGoodsValue;
    this.item.totalTax1 = this.totalTax1;
    this.item.totalTax2 = this.totalTax2;
    this.item.totalTax3 = this.totalTax3;
    this.item.totalTax = Number(
      this.totalTax1 + this.totalTax2 + this.totalTax3
    );

    this.setAccountingEntries();

    this.posService
      .returnPurchaseItem(this.item, this.paymentList, this.state.savedItemList, this.counterEntry)
      .then((res) => {
        if (res.original.alert == "info") {
          this.clearAll();
          this.item.searchReceiptNo = "";
          this.toast.showSuccess(res.original.msg);
          // if (isToggled === 'Pos Receipt'){
          //   this.generatePosReceipt(res);
          // } 
        }
      });


    this.paymentDialog = false;
    this.submitted = false;
  }

  validateItems(){
    let validated = 1;
    let errorMessage = '';
  
    // check for duplicates
    const seen = new Set();
    this.state.savedItemList.filter((item) => {
      if(!(item.unit > 0)){
        errorMessage = 'Please fill all the required fields to proceed'; // if item is already in the Set, it's a duplicate
        validated = 0;
      }
      
      var max_qty = (item.totalPurchacedUnits > item.stockQty) ? item.stockQty : item.totalPurchacedUnits;
      if(item.unit > max_qty){
        errorMessage = 'Cannot return excess quantities than Purchased'; // if item is already in the Set, it's a duplicate
        validated = 0;
      }
      // if(this.item.remark == ""){
      //   errorMessage = 'Please update the Remark to continue'; // if item is already in the Set, it's a duplicate
      //   validated = 0;
      // }
    });

    return {status: validated, message: errorMessage};
  }

  openPaymentMethod(isFormValid) {
    let validateDetails = this.validateItems();
    if(validateDetails.status == 0){
      this.validationPopupMessage = validateDetails.message;
      this.validationPopup = true;
      return false;
    }

    this.submitted = true;
    if ((isFormValid = true)) {
      this.paymentDialog = true;
      this.store.dispatch(
        ActionTypes.TOTAL_BILL,
        Number(this.fixDigits(this.netTotal))
      );
    }
  }

  get totalPaidCash()
  {
    let total = 0;

    this.paymentList.forEach(e => {
      if(e.paymentType == 'Cash')
      {
        total = total + e.transTotalAmount;
      }
    });

    return total;
  }

  get totalPaidBank()
  {
    let total = 0;

    this.paymentList.forEach(e => {
      if(e.paymentType != 'Cash')
      {
        total = total + e.transTotalAmount;
      }
    });

    return total;
  }

  getTotalPaid(paymnetList) {
    let totalPaid = 0;
    let totalTendered = 0;
    let totalChange = 0;

    paymnetList.forEach((e) => {
      if (e.paymentType != "Tip") {
        totalPaid = totalPaid + Number(e.transTotalAmount);
        totalTendered = totalTendered + Number(e.tendered);
        totalChange = totalChange + Number(e.change);
      }
    });

    return [totalPaid, totalTendered, totalChange];
  }

  get totalBalance()
  {
    return this.netTotal - this.item.totalPaid;
  }

  getPaymentMethod(paymentList) {
    let payMethod = "";
    let payMethodId = 0;

    if (paymentList.length == 0) {
      payMethod = "Pay Later";
      payMethodId = 2;
    } else if (paymentList.length == 1) {
      payMethod = paymentList[0].paymentType;
      payMethodId = paymentList[0].paymentTypeID;
    } else if (paymentList.length > 1) {
      payMethod = "Split";
      payMethodId = 0;
    }

    return {payMethod:payMethod, paymentMethodId:payMethodId};
  }

  // clearFreeUnit() {
  //   this.toast.showSuccess("Mode Changed Successfully");

  //   if (this.item.type == "RPU") {
  //     this.receiptDailog = true;
  //   }

  //   this.submitted = false;
  //   this.clearAll();
  // }

  fetchReceiptNo() {
    this.posService.getPurchaseItems(this.item.searchReceiptNo).then((data) => {
      this.clearAll();
      if(data.receipt == null){
        if(data.alert == 'info'){
          this.toast.showInfo(data.msg);
        } else {
          this.toast.showError(data.msg);
        }
      }

      if (data.receipt != null) {
        this.state.selectedProfile = data.receipt.profile_name.accountName;
        this.item.profileID = data.receipt.profile_name.id;
        this.item.billNo =
          data.receipt.bill_no == null
            ? ""
            : data.receipt.bill_no;
        this.item.description =
          data.receipt.description == null ? "" : data.receipt.description;
      }

      if (Array.isArray(data.receipt.pay_later)) {
        if (data.receipt.pay_later.length === 0) {
          this.cashPaymentOption = true;
          this.cardPaymentOption = true;
          this.paySupplierCredit = true;
        } else {
          this.cashPaymentOption = false;
          this.cardPaymentOption = false;
          this.paySupplierCredit = true;
        }

        // if the supplier is pharmacy? credit should disabled
        if (data.receipt.profile_name.id == 2) { //Config::get('profilers.default.supplier.id')
          this.paySupplierCredit = false;
        }
      } 

      if (data.receiptItems != null) {
        this.item.receiptID = data.receipt.id;
        this.paidAmount = data.receipt.total_tendered;
        this.initialTotalAmount = data.receipt.total_bill;
        data.receiptItems.forEach((e) => {
          this.state.savedItemList.push({
            mode: e.mode,
            stockID: Number(e.stock_id),
            productID: Number(e.product_id),
            productName: e.product_detail.product_name,
            generic: e.product_detail.generic_name,
            itemDescription: e.item_description,
            unit: (e.unit > e.stock_detail.qty) ? Number(e.stock_detail.qty):Number(e.unit),
            totalUnit: Number(e.unit),
            totalPurchacedUnits: Number(e.unit),
            stockQty: Number(e.stock_detail.qty),
            freeUnit: Number(e.free_unit),
            supplierBonus: Number(e.supplier_bonus),
            batchNo: e.stock_detail.batch_no,
            barcode: e.barcode,
            packSize: Number(e.pack_size),
            sheetSize: Number(e.sheet_size),
            purchasePrice: Number(e.purchase_price),
            orginalSPrice: Number(e.stock_detail.sale_price),
            sellingPrice: Number(e.selling_price),
            mrp: Number(e.mrp),
            brandName: e.brand_name,
            sectorName: e.sector_name,
            categoryName: e.category_name,
            productType: e.product_type,
            expiryDate: e.expiry_date,
            itemDisc: Number(e.purchase_disc),
            purchaseAfterDisc: Number(e.after_disc),
            cusDisc: Number(e.item_disc),
            minStockQty: Number(e.min_stock_qty),
            tax1: Number(e.tax_1),
            tax2: Number(e.tax_2),
            tax3: Number(e.tax_3),
            subTotal: Number(e.sub_total),
          });
        });

        this.receiptDailog = false;
      }
    });
  }


  redirectHome() {
    router.replace({ path: "/home/dashboard"});
  }

  
  setAccountingEntries() {
   
    this.counterEntry = [];

    if (this.item.type == "PUR") {

      this.counterEntry.push({
          accountID: 3,
          accountHead: 'Inventory',
          amount: this.totalGross-this.totalDiscAmount,
          type: "Debit",
      });

      //ADDING TAXES
      if (this.totalTax1 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[0].accountID,
          accountHead: this.taxNames[0].accountHead,
          amount: this.totalTax1,
          type: "Debit",
        });
      }

      if (this.totalTax2 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[1].accountID,
          accountHead: this.taxNames[1].accountHead,
          amount: this.totalTax2,
          type: "Debit",
        });
      }

      if (this.totalTax3 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[2].accountID,
          accountHead: this.taxNames[2].accountHead,
          amount: this.totalTax3,
          type: "Debit",
        });
      }


      if (this.totalBalance == 0) {

        if (this.totalPaidCash > 0) {
          this.counterEntry.push({
            accountID: 2,
            accountHead: 'Cash in hand',
            amount: this.totalPaidCash,
            type: "Credit",
          });
        }
        
        if (this.totalPaidBank > 0) {
          this.counterEntry.push({
            accountID: 8,
            accountHead: 'Cash at bank',
            amount: this.totalPaidBank,
            type: "Credit",
          });
        }

      } else if (this.totalBalance == this.netTotal) {
        this.counterEntry.push({
          accountID: 5,
          accountHead: "Accounts payable",
          amount: this.netTotal,
          type: "Credit",
        });
      } else if(this.totalBalance > 0 && this.item.totalPaid > 0) {
          if (this.totalPaidCash > 0) {
            this.counterEntry.push({
              accountID: 2,
              accountHead: 'Cash in hand',
              amount: this.totalPaidCash,
              type: "Credit",
            });
          }
          
          if (this.totalPaidBank > 0) {
            this.counterEntry.push({
              accountID: 8,
              accountHead: 'Cash at bank',
              amount: this.totalPaidBank,
              type: "Credit",
            });
          }

          this.counterEntry.push({
            accountID: 5,
            accountHead: "Accounts payable",
            amount: this.totalBalance,
            type: "Credit",
          });
      }
      
    } else if(this.item.type == "RPU") {

      if (this.totalBalance == 0) {

        if (this.totalPaidCash > 0) {
          this.counterEntry.push({
            accountID: 2,
            accountHead: 'Cash in hand',
            amount: this.totalPaidCash,
            type: "Debit",
          });
        }
        
        if (this.totalPaidBank > 0) {
          this.counterEntry.push({
            accountID: 8,
            accountHead: 'Cash at bank',
            amount: this.totalPaidBank,
            type: "Debit",
          });
        }

      } else if (this.totalBalance == this.netTotal) {
        this.counterEntry.push({
          accountID: 4,
          accountHead: "Accounts receivable",
          amount: this.netTotal,
          type: "Debit",
        });
      } else if(this.totalBalance > 0 && this.item.totalPaid > 0) {
          if (this.totalPaidCash > 0) {
            this.counterEntry.push({
              accountID: 2,
              accountHead: 'Cash in hand',
              amount: this.totalPaidCash,
              type: "Debit",
            });
          }
          
          if (this.totalPaidBank > 0) {
            this.counterEntry.push({
              accountID: 8,
              accountHead: 'Cash at bank',
              amount: this.totalPaidBank,
              type: "Debit",
            });
          }

          this.counterEntry.push({
            accountID: 4,
            accountHead: "Accounts receivable",
            amount: this.totalBalance,
            type: "Debit",
          });
      }

        this.counterEntry.push({
          accountID: 3,
          accountHead: 'Inventory',
          amount: this.totalGross-this.totalDiscAmount,
          type: "Credit",
      });

      //ADDING TAXES
      if (this.totalTax1 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[0].accountID,
          accountHead: this.taxNames[0].accountHead,
          amount: this.totalTax1,
          type: "Credit",
        });
      }

      if (this.totalTax2 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[1].accountID,
          accountHead: this.taxNames[1].accountHead,
          amount: this.totalTax2,
          type: "Credit",
        });
      }

      if (this.totalTax3 != 0) {
        this.counterEntry.push({
          accountID: this.taxNames[2].accountID,
          accountHead: this.taxNames[2].accountHead,
          amount: this.totalTax3,
          type: "Credit",
        });
      }
    }
    else
    {
      //NOTHING
    }
  }

  get currency() {
    return this.store.getters.getCurrency;
  }
 
  handleInput(event: KeyboardEvent) {
    const inputField = event.target as HTMLInputElement;
    const pressedKey = event.key;

      nextTick(() => {
        const updatedValue = inputField.value; // Value after the keypress is applied
        // //console.log("Pressed Key:", pressedKey);
        // //console.log("Updated Value:", updatedValue);
        
        if(updatedValue === "" && pressedKey === "Backspace" ){
          ////console.log("yes")
          //this.updateFirstPurchasePrice(0.00);
          //inputField.value = "0";
          //inputField.setSelectionRange(0, 0);
          
        }
        if (pressedKey === "." && updatedValue === ""){
          inputField.value = ".";
        }
      });
  }

  
validateProductItem(item, productIdSet, rowIndex): string[] {
  const errors:string[]= [];

  // Check productId: must be integer and unique
  if (!this.isInteger(item.productId)) {
    errors.push(`Row ${rowIndex}: productId (${!item.productId?'empty':item.productId}) must be an integer.`);
  } else {
    const idNum = Number(item.productId);
    if (productIdSet.has(idNum)) {
      errors.push(`Row ${rowIndex}: Duplicate productId (${item.productId}) found.`);
    } else {
      productIdSet.add(idNum);
    }
  }

  // unitQty is required and must be integer
  if (!this.isInteger(item.unitQty)) {
    errors.push(`Row ${rowIndex}: unitQty (${item.unitQty}) must be an integer.`);
  }

  // freeQty can be optional but if provided must be an integer
  if (item.freeQty !== null && item.freeQty !== '' && item.freeQty !== undefined) {
    if (!this.isInteger(item.freeQty)) {
      errors.push(`Row ${rowIndex}: freeQty (${item.freeQty}) must be an integer if provided.`);
    }
  }

  // supBonus, unitDisc, cusDisc are optional but must be numbers if provided
  ['supBonus', 'unitDisc', 'cusDisc'].forEach((field) => {
    if (item[field] !== null && item[field] !== '' && item[field] !== undefined) {
      if (!this.isNumeric(item[field])) {
        errors.push(`Row ${rowIndex}: ${field} (${item[field]}) must be a number if provided.`);
      }
    }
  });

  if (!this.isNumeric(item.unitPurchase)) {
    errors.push(`Row ${rowIndex}: unitPurchase (${item.unitPurchase}) must be a number.`);
  }

  // Required fields: batchNo, unitPurchase, mrp, expiryDate
  ['batchNo', 'unitPurchase', 'mrp', 'expiryDate'].forEach((field) => {
    if (!item[field] || item[field].toString().trim() === '') {
      errors.push(`Row ${rowIndex}: ${field} is required.`);
    }
  });

  // expiryDate should be in valid date format (if provided)
  // if (!this.isValidDate(item.expiryDate)) {
  //   errors.push(`Row ${rowIndex}: expiryDate (${item.expiryDate}) is not a valid date.`);
  // }

  if (!this.convertAndValidateDate(item.expiryDate)) {
    errors.push(`Row ${rowIndex}: expiryDate (${item.expiryDate}) is not a valid date.`);
  }

  
  return errors;
}

convertAndValidateDate(dateStr: string): string | null {
  // Accept both single and double digits for month/day
  //console.log("DATE BEFORE ",dateStr);
  const mmddyyyyRegex = /^([1-9]|0[1-9]|1[0-2])\/([1-9]|0[1-9]|[12]\d|3[01])\/\d{4}$/;

  if (!mmddyyyyRegex.test(dateStr)) {
    console.warn(`Invalid date format: ${dateStr}`);
    return null;
  }

  const [month, day, year] = dateStr.split('/');

  // Pad month and day with zeros if needed
  const paddedMonth = month.padStart(2, '0');
  const paddedDay = day.padStart(2, '0');

  const shortYear = year.slice(-2);
  this.productItem.expiryDate = `${paddedDay}-${paddedMonth}-${shortYear}`;

  return `${paddedDay}-${paddedMonth}-${shortYear}`;
}



isInteger(value): boolean {
  if (value === null || value === undefined) return false;
  return Number.isInteger(Number(value));
}

isNumeric(value): boolean {
  if (value === null || value === undefined) return false;
  return !isNaN(parseFloat(value)) && isFinite(value);
}

isValidDate(dateStr): boolean {
  if (!dateStr) return false;

  const date = new Date(dateStr);
  return !isNaN(date.getTime());
}

showErrorMessages(errors: string[]): void {
  // You can implement this to show errors in your UI
  // Example: show in dialog or toaster notification
  alert(errors.join('\n')); // Simple alert for demonstration
}


   // Extract product IDs and fetch items
   fetchItemsFromExcel() {
      // Extract 'productId' from each object in excelFileContent
      //console.log("EXCEL FILE CONTENT ", this.excelFileContent);
      const productIDs = this.excelFileContent.map(item => item.productId);

      if (productIDs.length > 0) {
          this.getItemsByProductId(productIDs);
      } else {
          this.toast.showInfo('No Product IDs Found');
      }
  }

  getItemsByProductId(productIDs) {
    //console.log("PRODUCT IDS IN VUE ", productIDs);
    setTimeout(() => {
      this.posService.getPurItems(productIDs).then((data) => {
        if(data.records.length == 0){
          this.toast.showInfo('No Item Found');
        } else {
          this.productsList = data.records;
          //console.log("PRODUCT LIST", this.productsList);
          this.updateSavedItemList();
        }
      });
    }, 200);
  }

   


  updateSavedItemList() {
    //console.log("UPDATE SAVED ITEM LIST FUNCTION");
    //console.log("PRODUCTS LIST ", this.productsList);

    if (!this.productsList || this.productsList.length === 0) {
        this.toast.showInfo('No Product Data Available');
        return;
    }
    this.productsList.forEach((itemInfo:any, index) => {
      let uploadedData = this.excelFileContent[index];

        this.state.savedItemList.push({
            mode: "Pack",
            stockID: 0,
            productID: itemInfo.id,  // Assuming 'id' is the product ID
            productName: itemInfo.product_name,  // Adjust according to actual data structure
            generic: itemInfo.generic_name,
            itemDescription: itemInfo.description,
            unit: 1,
            totalUnit: Number(uploadedData.unitQty),
            totalPurchacedUnits:0,
            stockQty: Number(itemInfo.qty) || 0,
            freeUnit: Number(uploadedData.freeQty),
            supplierBonus: Number(uploadedData.supBonus),
            batchNo: uploadedData.batchNo, // You can update this logic if needed
            barcode: uploadedData.barcode,
            packSize: 1, // Adjust if necessary
            sheetSize: 1, // Adjust if necessary
            purchasePrice: Number(uploadedData.unitPurchase), // Adjust if necessary
            orginalSPrice: 0, // Adjust if necessary
            sellingPrice: 0, // Adjust if necessary
            mrp: Number(uploadedData.mrp), // Adjust if necessary
            brandName: itemInfo.bName,
            sectorName: itemInfo.bSector,
            categoryName: itemInfo.cName,
            productType: itemInfo.pType,
            expiryDate: uploadedData.expiryDate,
            cusDisc: Number(uploadedData.cusDisc), // Adjust if necessary
            minStockQty: Number(itemInfo.min_stock_qty) || 0,
            purchaseAfterDisc: 0,
            itemDisc: Number(uploadedData.unitDisc),
            tax1: 0, // Adjust if necessary
            tax2: 0, // Adjust if necessary
            tax3: 0, // Adjust if necessary
            subTotal: 0,
        });
    });

    this.toast.showSuccess('Products added successfully');
}

  // clearAll() {
  //   this.excelFileContent = [];
  //   this.toast.showSuccess("Cleared Successfully");
  // }

  // save() {
  //   this.submitted = true;
  //       this.optionTag
  //         .saveItem(this.excelFileContent)
  //         .then((res) => {
  //           this.goToFirstLink = 0;
  //           this.loadList(this.goToFirstLink);
  //           //SHOW NOTIFICATION
  //           this.toast.handleResponse(res);
  //           this.clearAll();
  //         });
      

  //     this.productDialog = false;
  //     this.item.id = 0;
  //     this.item.description = "";
  //     this.item.status = "";
  // }

}
